import React, { useEffect, useState } from "react";
import { Box, Typography, Link, Paper } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { baseUrl } from "../../../helper/urls";
import { useSelector } from "react-redux";
import Highlights from "./Highlights";
import CeoStatement from "./CeoStatement";
import WebinarCarousel from "./WebinarCarousel";
import StoryCarousal from "./StoryCarousal";

const SectionHeading = ({ children, ...props }) => (
  <Typography
    variant="h6"
    fontSize={18}
    color="#1e3a8a"
    borderBottom="2px solid #dbeafe"
    pb={0.75}
    {...props}
  >
    {children}
  </Typography>
);

export default function StudentSidebar() {
  const { token } = useSelector((state) => state.auth);
  const [expanded, setExpanded] = useState(false);

  const [contentDataList, setcontentDataList] = useState([]);
  const [loading, setLoading] = useState(true);
  const contentListApi = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/policy/content/student`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setcontentDataList(response.data.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching FAQs:", error);
      toast.error("Failed to fetch FAQs.");
      setLoading(false);
    }
  };
  useEffect(() => {
    contentListApi();
  }, []);

  const storyData = contentDataList?.filter(
    (item) => item.category === "story"
  );

  const highlightsData = contentDataList?.filter(
    (item) => item.category === "highlight"
  );

  const webinarData = contentDataList?.filter(
    (item) => item.category === "webinar"
  );
  console.log("webinarData: ", webinarData);

  const statementData = contentDataList?.filter(
    (item) => item.category === "statement"
  );

  return (
    <>
      <>
        <Box
          display="flex"
          fontFamily="'Segoe UI', sans-serif"
          bgcolor="#ffffff"
          mt={-3}
        >
          {/* Right‑hand menu */}
          <Box
            component="aside"
            width={340}
            p={3}
            bgcolor="#f8fafc"
            sx={{
              borderLeft: "4px solid #1e3a8a",
              boxShadow: "-4px 0 12px rgba(0,0,0,0.05)",
              position: "sticky",
              top: 0,
              height: "100vh",
              overflowY: "auto",
            }}
          >
            {/* Top stories */}
            <SectionHeading sx={{ mb: 4 }}>
              📢 Monthly Top Stories
            </SectionHeading>
            <StoryCarousal storyData={storyData} />

            {/* Highlights */}
            <SectionHeading sx={{ mt: 5 }}>
              🌟 DreamDor Highlights
            </SectionHeading>
            <Highlights highlightsData={highlightsData} />

            {/* Webinar */}
            <SectionHeading sx={{ mt: 4 }}>
              🎓 Monthly Free Webinar
            </SectionHeading>
            <WebinarCarousel webinarData={webinarData} />

            {/* CEO Statement */}
            <SectionHeading sx={{ mt: 4 }}>💬 CEO Statement</SectionHeading>
            <CeoStatement statementData={statementData} />
          </Box>
        </Box>
      </>
      <>
        <ToastContainer position="bottom-center" />
      </>
    </>
  );
}
